import cn from 'classnames';
import React from 'react';
import { headerBlock as block } from '../../utils';
import ClipSelectViewToggle from './ClipSelectViewToggle';
import HeaderContainer from './HeaderContainer';
import HeaderPodcastInfo from './HeaderPodcastInfo';
import HeaderSelectClipActions from './HeaderSelectClipActions';

export type SelectClipHeaderProps = {
  className?: string;
};

const SelectClipHeader: React.FC<SelectClipHeaderProps> = ({ className }) => {
  return (
    <HeaderContainer className={cn(block('select'), className)}>
      <HeaderPodcastInfo />
      <ClipSelectViewToggle />
      <HeaderSelectClipActions />
    </HeaderContainer>
  );
};

export default SelectClipHeader;
